import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Grid, Checkbox, FormGroup, FormControlLabel } from '@material-ui/core';
import AppInput from '../../../../common/AppInput';
import AppSelect from '../../../../common/AppSelect';
import { schema } from './validation/schema';
import {
  getInitialCities,
  getCitiesOfProvidence,
  getProvidencesOfRegion,
} from './../../../../../helpers/addresses/AddressesHelper';

const InnerForm = ({ ...props }) => {
  const {
    state,
    dispatch,
    onClick,
    handleIsPrimary,
    address,
    isPrimaryAddress,
    profile,
    showThirdLevel,
    splitStreetInput,
    isBillAddress,
  } = props;
  const regions = useSelector((state) => state.regionsReducer.regions);

  const [providences, setProvidences] = useState(
    address ? getProvidencesOfRegion(regions, address.state) : [],
  );
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (showThirdLevel && address) {
      const cities = getInitialCities(regions, address.state, address.city);
      setCities(cities);
    }
  }, [showThirdLevel]);

  const handleInputChange = (event) => {
    dispatch({
      field: event.target.name,
      value: {
        value: event.target.value,
        error: state[event.target.name].error,
        message: state[event.target.name].message,
        helper: state[event.target.name].helper,
        inputAdornment: state[event.target.name].inputAdornment,
        label: state[event.target.name].label,
        success: state[event.target.name].success,
      },
    });
    if (event.target.name === 'level1') {
      setProvidences(getProvidencesOfRegion(regions, event.target.value));
      setCities([]);
    } else if (showThirdLevel && event.target.name === 'level2') {
      setCities(
        getCitiesOfProvidence(
          regions,
          state['level1'].value,
          event.target.value,
        ),
      );
    }
  };
  const handleClick = (event) => {
    onClick(event.target.value);
  };

  const handleValidation = (event) => {
    if ('error' in schema.validate({ [event.target.name]: event.target.value }))
      dispatch({
        field: event.target.name,
        value: {
          value: event.target.value,
          error: true,
          message: schema.validate({ [event.target.name]: event.target.value })
            .error.message,
          helper: state[event.target.name].helper,
          inputAdornment: state[event.target.name].inputAdornment,
          label: state[event.target.name].label,
          success: false,
        },
      });
    else
      dispatch({
        field: event.target.name,
        value: {
          value: event.target.value,
          error: false,
          message: '',
          helper: state[event.target.name].helper,
          inputAdornment: state[event.target.name].inputAdornment,
          label: state[event.target.name].label,
          success: true,
        },
      });
  };

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AppInput
            name="addressName"
            error={state['addressName'].error}
            value={state['addressName'].value}
            label={state['addressName'].label}
            helperText={state['addressName'].helper}
            inputAdornment={state['addressName'].inputAdornment}
            errorMessage={state['addressName'].message}
            success={state['addressName'].success}
            disabled={address ? true : false}
            required
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
          ></AppInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <AppInput
            name="name"
            error={state['name'].error}
            value={state['name'].value}
            label={state['name'].label}
            helperText={state['name'].helper}
            inputAdornment={state['name'].inputAdornment}
            errorMessage={state['name'].message}
            success={state['name'].success}
            required
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
            disabled={
              !profile.addressLine ? true : address && address.isMainCommerce
            }
          ></AppInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <AppInput
            name="lastname"
            error={state['lastname'].error}
            value={state['lastname'].value}
            label={state['lastname'].label}
            helperText={state['lastname'].helper}
            inputAdornment={state['lastname'].inputAdornment}
            errorMessage={state['lastname'].message}
            success={state['lastname'].success}
            required
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
            disabled={
              !profile.addressLine ? true : address && address.isMainCommerce
            }
          ></AppInput>
        </Grid>
        <Grid item xs={12} md={splitStreetInput ? 6 : 12}>
          <AppInput
            name="street"
            error={state['street'].error}
            value={state['street'].value}
            label={state['street'].label}
            helperText={state['street'].helper}
            inputAdornment={state['street'].inputAdornment}
            errorMessage={state['street'].message}
            success={state['street'].success}
            required
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
          ></AppInput>
        </Grid>
        {splitStreetInput && (
          <React.Fragment>
            <Grid item xs={12} md={6}>
              <AppInput
                name="number"
                error={state['number'].error}
                value={state['number'].value}
                label={state['number'].label}
                helperText={state['number'].helper}
                inputAdornment={state['number'].inputAdornment}
                errorMessage={state['number'].message}
                success={state['number'].success}
                required
                onChange={handleInputChange}
                onClick={handleClick}
                onBlur={handleValidation}
              ></AppInput>
            </Grid>
            <Grid item xs={12} md={6}>
              <AppInput
                name="houseType"
                error={state['houseType'].error}
                value={state['houseType'].value}
                label={state['houseType'].label}
                helperText={state['houseType'].helper}
                inputAdornment={state['houseType'].inputAdornment}
                errorMessage={state['houseType'].message}
                success={state['houseType'].success}
                required
                onChange={handleInputChange}
                onClick={handleClick}
                onBlur={handleValidation}
              ></AppInput>
            </Grid>
          </React.Fragment>
        )}
        <Grid item xs={12} md={6}>
          <AppSelect
            name="level1"
            error={state['level1'].error}
            value={state['level1'].value}
            label={state['level1'].label}
            errorMessage={state['level1'].message}
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
            options={regions}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <AppSelect
            name="level2"
            error={state['level2'].error}
            value={state['level2'].value}
            label={state['level2'].label}
            errorMessage={state['level2'].message}
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
            options={providences}
          />
        </Grid>
        {showThirdLevel && (
          <Grid item xs={12} md={6}>
            <AppSelect
              name="level3"
              error={state['level3'].error}
              value={state['level3'].value}
              label={state['level3'].label}
              errorMessage={state['level3'].message}
              onChange={handleInputChange}
              onClick={handleClick}
              onBlur={handleValidation}
              options={cities}
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          <AppInput
            name="phone"
            error={state['phone'].error}
            value={state['phone'].value}
            label={state['phone'].label}
            helperText={state['phone'].helper}
            inputAdornment={state['phone'].inputAdornment}
            errorMessage={state['phone'].message}
            success={state['phone'].success}
            required
            onChange={handleInputChange}
            onClick={handleClick}
            onBlur={handleValidation}
            disabled={!profile.addressLine && profile.phone1}
          ></AppInput>
        </Grid>
      </Grid>
      {address && address.primary !== 'true' && !isBillAddress && (
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={isPrimaryAddress} />}
            onChange={handleIsPrimary}
            label="Utilizar esta dirección como principal para los despachos"
          />
        </FormGroup>
      )}
    </React.Fragment>
  );
};

InnerForm.propTypes = {
  state: PropTypes.object,
  dispatch: PropTypes.object,
  onClick: PropTypes.func,
  handleIsPrimary: PropTypes.func,
  address: PropTypes.object,
  isPrimaryAddress: PropTypes.bool,
  profile: PropTypes.object,
  showThirdLevel: PropTypes.bool,
  splitStreetInput: PropTypes.func,
  isBillAddress: PropTypes.bool,
};

export default InnerForm;
